"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../Typography"));
exports.Container = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.theme.constants.badgeSize.md}px;
  height: ${props => props.theme.constants.badgeSize.md}px;
  background-color: ${props => props.theme.palette.ORANGE_100};
  border-radius: ${props => props.theme.attributes.borderRadius.lg}px;
`;
exports.Label = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.BW_100};
`;
exports.default = {
    Container: exports.Container,
    Label: exports.Label
};
